import { gql } from "apollo-boost";

export const GET_SALE_ORDERS = gql`
query Data($where: ReportWhereInput!, $limit: Int, $skip: Int, $orderBy: OrderByInput) {
    reportSaleOrders(where: $where, limit: $limit, skip: $skip, orderBy: $orderBy) {
      total
      data {
        id
        amount
        stock {
          id
          name
          amount
          price
          originPrice
          barCode
          note
          
        }
        price
        totalPrice
        totalPriceBaht
        totalPriceUsd
        note
        isDeleted
        createdAt
        updatedAt
        productName
      }
    }
  }
`;
 